module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldSemiExt.2ec759b.woff";